import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import { handleChildClose, handleClose, setCurrentHomeModalKey, setCurrentPage, setCurrentPageData, setDeleteUpdateTag, setFormData, setHomeScreenData, setHomeScreenSectionData, setIsLoading, setIsModalLoading, setMultiCountry, setMultiRegion, setPerPage, setPermissions, setToastMessage, setTokenType, setTotalPage, setEncodingString, setZipValidationMessage, setEventDate, setConfigData, configData, setIsChildLoading, setCurrentPageChildData, setAddEditDeleteTag } from "../reducers/contextSlice";
const socket = require('socket.io-client').connect(process.env.REACT_APP_SUPER_SOCKET_URL, { transports: ['polling'] })



export const baseURL = process.env.REACT_APP_API_BASE_URL;
// export const baseURL = 'http://172.16.31.68:8008';
export const superAppBaseURL = process.env.REACT_APP_SUPER_API_BASE_URL;

const COMMON_ERROR = "Error, Please try again.!";
const errorResponse = (error, dispatch) => {
    if (error.response) {
        const { status, data } = error.response;
        if (status === 403) {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
            return dispatch(logout())
        };
        return data;
    } else {
        return { status: 0, message: COMMON_ERROR };
    };
};

let setFormDataPayload = (_payload) => {
    let formData = new FormData();

    // Helper function to recursively build FormData
    const buildFormData = (data, parentKey = '') => {
        for (let key in data) {
            const value = data[key];
            const newKey = parentKey ? `${parentKey}[${key}]` : key;
            if (key === "gameCategory") {
                data[key]?.forEach((_item) => formData?.append(`${key}`, _item))

            } else if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'object') {
                // If the value is an array of objects, iterate through each object
                value.forEach((item, index) => {
                    // Recursively call buildFormData for each object
                    buildFormData(item, `${newKey}[${index}]`);
                });
            } else if (value instanceof FileList) {
                // If the value is a FileList object, append each file to the same key
                for (let i = 0; i < value.length; i++) {
                    formData.append(`${newKey}`, value[i]);
                }
            } else if (data[key] instanceof File) {
                // If the value is a File object, append it directly
                formData.append(key, data[key]);
            } else if (!Array.isArray(value) && typeof value === "object" && value !== null) {

                buildFormData(value, newKey);
            } else if (Array.isArray(value)) {
                value.forEach((item, index) => {
                    formData.append(`${newKey}[${index}]`, item);
                });
            } else {
                formData.append(newKey, value);
            }
        }
    };

    // Start building FormData from the top-level payload
    buildFormData(_payload);
    return formData;
};

//API Instance

const API = axios.create({ baseURL: `${baseURL}/` });
API.interceptors.request.use((req) => {
    let token = localStorage.getItem('token');
    if (token) {
        req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
});

const SUPER_API = axios.create({ baseURL: `${superAppBaseURL}` });
SUPER_API.interceptors.request.use((req) => {
    let token = localStorage.getItem('token');
    if (token) {
        req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
});

//log in
export const login = createAsyncThunk('login', async (value, { rejectWithValue, dispatch, getState }) => {
    try {
        // const { navigate } = extra;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/signIn`, value);

        if (data && data.status) {
            localStorage.setItem("token", data.token);
            localStorage.setItem("loginType", 'standard')
            localStorage.setItem("userName", data.name);
            // window.location.pathname = "/dashboard";
            // navigate('/dashboard')

            dispatch(setToastMessage({ type: 'success', message: data?.message }));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setToastMessage({ type: 'error', message: error?.response?.data?.message || 'Request Failed' }));
    }
})

export const LDAP_login = createAsyncThunk('LDAPlogin', async (value, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        const { data } = await SUPER_API.post('/admin/loginWithLdap', value);
        if (data && data.status) {
            localStorage.setItem("token", data.token);
            // const object = JSON.parse(atob(data?.token.split('.')[1]))
            const [_, payload, _$] = data?.token?.split('.');
            dispatch(setPermissions(JSON.parse(atob(payload))?.permission))
            dispatch(setTokenType('ldap'))
            // const decodeToken = jwtDecode(data?.token);
            socket.emit('join', { userId: JSON.parse(atob(payload))?._id })
            localStorage.setItem("loginType", 'ldap');
            localStorage.setItem("userName", data?.name);
            window.location.pathname = "/";
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
        }
        else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        }
        dispatch(setIsLoading(false));
        return;
    }
    catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setToastMessage({ type: 'error', message: error?.response?.data?.message || 'Request Failed' }));
    }
})

// log out 
export const logout = createAsyncThunk('logout', async (value, { rejectWithValue, dispatch, getState }) => {
    try {
        // const { data } = await API.post(`/admin/logout`);
        // if (data?.status) {
        localStorage.clear();
        window.location.reload();
        // } else {
        //     dispatch(setToastMessage({ type: 'error', message: data?.message }));
        // };
        return;
    } catch (error) {
        dispatch(setToastMessage({ type: 'error', message: error?.response?.data?.message || 'Request Failed' }));
        // return errorResponse(error, dispatch);
    }
})
export const get_country = createAsyncThunk('get_country', async (payload, { rejectWithValue, dispatch }) => {
    try {
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/getCountry`);
        return data.data;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})


export const add_country = createAsyncThunk('add_country', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        // let formData = setFormDataPayload(payload);
        const { data } = await API.post(`/admin/addCountry`, payload);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_country = createAsyncThunk('update_country', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        // let formData = setFormDataPayload(payload);
        const { data } = await API.patch(`/admin/updateCountry?id=${id}`, payload);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_country = createAsyncThunk('delete_country', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/deleteCountry?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_country = createAsyncThunk('delete_all_country', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/deleteAllCountry`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const get_country_data = createAsyncThunk('get_country_data', async (payload, { rejectWithValue, dispatch }) => {
    try {
        let apiData;
        let getCountry;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getCountry = await API.post(`/admin/getCountry?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getCountry = await API.post(`/admin/getCountry`);
        }
        const { status, data, currentPage, perPage, totalPage } = getCountry?.data;

        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));

        }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const get_regions = createAsyncThunk('get_regions', async (page, { rejectWithValue, dispatch }) => {
    try {
        dispatch(setIsLoading(true));
        const { data } = await API.get(`/admin/getRegion`);
        dispatch(setIsLoading(false));
        return data.data;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})


// ===========================================================================================================================================================
// diy background data
export const get_background_data = createAsyncThunk('get_background_data', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getBackgroundList;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getBackgroundList = await API.post(`/admin/getBackgroundlist?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getBackgroundList = await API.get(`/admin/getBackgroundlist`);
        }

        // if (getBackgroundList) {
        const { status, data, currentPage, perPage, totalPage } = getBackgroundList?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));

        }
        // }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setCurrentPageData([]));
        dispatch(setIsLoading(false));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const get_background_category_dropdown_data = createAsyncThunk('get_background_category_dropdown_data', async ({ currentPage = 1, perPage, search, filterDropdown }, { rejectWithValue, dispatch, getState }) => {
    try {
        // dispatch(setIsLoading(true));
        if (currentPage || perPage || search || filterDropdown) {
            const { data } = await API.post(`/admin/getBackgroundCategory?page=${currentPage}&perPage=${perPage}&search=${search}`, filterDropdown)
            // dispatch(setIsLoading(false));
            return data.data;
        } else {
            const { data } = await API.post(`/admin/getBackgroundCategory`)
            // dispatch(setIsLoading(false));
            return data.data;
        }

    } catch (error) {
        // dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_diy_background = createAsyncThunk('add_diy_background', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        let formData = setFormDataPayload(payload);
        const { data } = await API.post(`/admin/addBackgroundList`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})


export const update_diy_background = createAsyncThunk('update_diy_background', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        let formData = setFormDataPayload(payload);
        const { data } = await API.patch(`/admin/updateBackgroundList?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_diy_background = createAsyncThunk('delete_diy_background', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/deleteBackgroundlist?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_diy_background = createAsyncThunk('delete_all_diy_background', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/deleteAllBackgroundlist`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

//dyi keys
export const get_diy_keys = createAsyncThunk('get_diy_keys', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getBackgroundList;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getBackgroundList = await API.post(`/admin/getKeyList?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getBackgroundList = await API.get(`/admin/getKeyList`);
        }
        // if (getBackgroundList) {
        const { status, data, currentPage, perPage, totalPage } = getBackgroundList?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        // }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setCurrentPageData([]));
        dispatch(setIsLoading(false));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const add_diy_keys = createAsyncThunk('add_diy_keys', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        let formData = setFormDataPayload(payload);
        const { data } = await API.post(`/admin/addKeyList`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_diy_keys = createAsyncThunk('update_diy_keys', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        let formData = setFormDataPayload(payload);
        const { data } = await API.patch(`/admin/updateKeyList?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_diy_keys = createAsyncThunk('delete_diy_keys', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/deleteKeyList?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_diy_keys = createAsyncThunk('delete_all_diy_keys', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/deleteAllKeyList`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

//dyi keys categories

export const get_keys_category_dropdown_data = createAsyncThunk('get_keys_category_dropdown_data', async ({ currentPage = 1, perPage, search, filterDropdown }, { rejectWithValue, dispatch, getState }) => {
    try {
        // dispatch(setIsLoading(true));
        if (currentPage || perPage || search || filterDropdown) {
            const { data } = await API.post(`/admin/getKeyCategory?page=${currentPage}&perPage=${perPage}&search=${search}`, filterDropdown)
            // dispatch(setIsLoading(false));
            return data.data;
        } else {
            const { data } = await API.post(`/admin/getKeyCategory`)
            // dispatch(setIsLoading(false));
            return data.data;
        }

    } catch (error) {
        // dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const get_diy_keys_categories = createAsyncThunk('get_diy_keys_categories', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getBackgroundList;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getBackgroundList = await API.post(`/admin/getKeyCategory?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getBackgroundList = await API.get(`/admin/getKeyCategory`);
        }

        // if (getBackgroundList) {
        const { status, data, currentPage, perPage, totalPage } = getBackgroundList?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));

        }
        // }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const add_diy_keys_categories = createAsyncThunk('add_diy_keys_categories', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        // let formData = setFormDataPayload(payload);
        const { data } = await API.post(`/admin/addKeyCategory`, payload);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_diy_keys_categories = createAsyncThunk('update_diy_keys_categories', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        // let formData = setFormDataPayload(payload);
        const { data } = await API.patch(`/admin/updateKeyCategory?id=${id}`, payload);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_diy_keys_categories = createAsyncThunk('delete_diy_keys_categories', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/deleteKeyCategory?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_diy_keys_categories = createAsyncThunk('delete_all_diy_keys_categories', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/deleteAllKeyCategory`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})


// diy background categories
export const get_diy_background_category = createAsyncThunk('get_diy_background_category', async (payload, { rejectWithValue, dispatch, getState }) => {

    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getBackgroundList;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getBackgroundList = await API.post(`/admin/getBackgroundCategory?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getBackgroundList = await API.get(`/admin/getBackgroundCategory`);
        }

        // if (getBackgroundList) {
        const { status, data, currentPage, perPage, totalPage } = getBackgroundList?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));

        }
        // }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})
// 
export const add_diy_background_categories = createAsyncThunk('add_diy_background_categories', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const { data } = await API.post(`/admin/addBackgroundCategory`, payload);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})
// 
export const update_diy_background_categories = createAsyncThunk('update_diy_background_categories', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const { data } = await API.patch(`/admin/updateBackgroundCategory?id=${id}`, payload);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_diy_background_categories = createAsyncThunk('delete_diy_background_categories', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/deleteBackgroundCategory?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_diy_background_categories = createAsyncThunk('delete_all_diy_background_categories', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/deleteAllBackgroundCategory`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})


// Diy Font List
export const get_diy_font_list = createAsyncThunk('get_diy_font_list', async (payload, { rejectWithValue, dispatch, getState }) => {

    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getFontList;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getFontList = await API.post(`/admin/getFontlist?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getFontList = await API.get(`/admin/getFontlist`);
        }

        // if (getBackgroundList) {
        const { status, data, currentPage, perPage, totalPage } = getFontList?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        // }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})


export const add_diy_font_list = createAsyncThunk('add_diy_font_list', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        let formData = setFormDataPayload(payload);
        const { data } = await API.post(`/admin/addFontlist`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        // dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_diy_font_list = createAsyncThunk('update_diy_font_list', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.patch(`/admin/updateFontlist?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        // dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_diy_font_list = createAsyncThunk('delete_diy_font_list', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/deleteFontlist?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_diy_font_list = createAsyncThunk('delete_all_diy_font_list', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/deleteAllFontlist`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

// diy effects
export const get_diy_effects = createAsyncThunk('get_diy_effects', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getBackgroundList;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getBackgroundList = await API.post(`/admin/getEffect?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getBackgroundList = await API.get(`/admin/getEffect`);
        }

        // if (getBackgroundList) {
        const { status, data, currentPage, perPage, totalPage } = getBackgroundList?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));

        }
        // }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const update_diy_effects = createAsyncThunk('update_diy_effects', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.patch(`/admin/updateEffect?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_diy_effects = createAsyncThunk('add_diy_effects', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.post(`/admin/addEffect`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_diy_effects = createAsyncThunk('delete_diy_effects', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/deleteEffect?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_diy_effects = createAsyncThunk('delete_all_diy_effects', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/deleteAllEffect`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

// diy sounds
export const get_diy_sounds = createAsyncThunk('get_diy_sounds', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getBackgroundList;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getBackgroundList = await API.post(`/admin/getSound?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getBackgroundList = await API.get(`/admin/getSound`);
        }

        // if (getBackgroundList) {
        const { status, data, currentPage, perPage, totalPage } = getBackgroundList?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        // }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setCurrentPageData([]));
        dispatch(setIsLoading(false));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const update_diy_sound = createAsyncThunk('update_diy_sound', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.patch(`/admin/updateSound?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_diy_sounds = createAsyncThunk('add_diy_sounds', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.post(`/admin/addSound`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_diy_sounds = createAsyncThunk('delete_diy_sounds', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/deleteSound?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_diy_sounds = createAsyncThunk('delete_all_diy_sounds', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/deleteAllSound`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

// diy lenses
export const get_diy_lenses = createAsyncThunk('get_diy_lenses', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getLenseList;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getLenseList = await API.post(`/admin/getLense?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getLenseList = await API.get(`/admin/getLense`);
        }
        const { status, data, currentPage, perPage, totalPage } = getLenseList?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const update_diy_lenses = createAsyncThunk('update_diy_lenses', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.patch(`/admin/updateLense?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_diy_lenses = createAsyncThunk('add_diy_lenses', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.post(`/admin/addLense`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_diy_lenses = createAsyncThunk('delete_diy_lenses', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/deleteLense?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_diy_lenses = createAsyncThunk('delete_all_diy_lenses', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/deleteAllLense`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

//dyi Swipes
export const get_diy_swipes = createAsyncThunk('get_diy_swipes', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getSwipesList;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getSwipesList = await API.post(`/admin/getSwipe?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getSwipesList = await API.get(`/admin/getSwipe`);
        }

        const { status, data, currentPage, perPage, totalPage } = getSwipesList?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const add_diy_swipes = createAsyncThunk('add_diy_swipes', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        let formData = setFormDataPayload(payload);
        const { data } = await API.post(`/admin/addSwipe`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_diy_swipes = createAsyncThunk('update_diy_swipes', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        let formData = setFormDataPayload(payload);
        const { data } = await API.patch(`/admin/updateSwipe?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_diy_swipes = createAsyncThunk('delete_diy_swipes', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/deleteSwipe?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_diy_swipes = createAsyncThunk('delete_all_diy_swipes', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/deleteAllSwipe`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

//dyi Autos
export const get_diy_autos = createAsyncThunk('get_diy_autos', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getAutosList;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getAutosList = await API.post(`/admin/getAuto?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getAutosList = await API.get(`/admin/getAuto`);
        }

        const { status, data, currentPage, perPage, totalPage } = getAutosList?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const add_diy_autos = createAsyncThunk('add_diy_autos', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        let formData = setFormDataPayload(payload);
        const { data } = await API.post(`/admin/addAuto`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_diy_autos = createAsyncThunk('update_diy_autos', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        let formData = setFormDataPayload(payload);
        const { data } = await API.patch(`/admin/updateAuto?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_diy_autos = createAsyncThunk('delete_diy_autos', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/deleteAuto?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_diy_autos = createAsyncThunk('delete_all_diy_autos', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/deleteAllAuto`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

// Theme Tag
export const get_theme_tag = createAsyncThunk('get_theme_tag', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getThemeTag;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getThemeTag = await API.post(`/admin/theme/getThemeTag?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getThemeTag = await API.get(`/admin/theme/getThemeTag`);
        }

        // if (getThemeTag) {
        const { status, data, currentPage, perPage, totalPage } = getThemeTag?.data;
        if (status) {
            apiData = data;
            ;
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        // }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const get_theme_tag_dropdown = createAsyncThunk('get_theme_tag_dropdown', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        // dispatch(setIsLoading(true));
        let getThemeTag = await API.post(`/admin/theme/getThemeTag?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search}`, payload?.filterDropdown);

        // if (getThemeTag) {
        const { data } = getThemeTag;

        // }
        // dispatch(setIsLoading(false));
        return data.data;
    } catch (error) {
        // dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_theme_tag = createAsyncThunk('add_theme_tag', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const { data } = await API.post(`/admin/theme/addThemeTag`, payload);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(handleChildClose());
            dispatch(setCurrentHomeModalKey(""));
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_theme_tag_child = createAsyncThunk('add_theme_tag_child', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const { data } = await API.post(`/admin/theme/addThemeTag`, payload);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleChildClose());
            dispatch(setCurrentHomeModalKey(""));
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})


export const update_theme_tag = createAsyncThunk('update_theme_tag', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const { data } = await API.patch(`/admin/theme/updateThemeTag?id=${id}`, payload);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_theme_tag = createAsyncThunk('delete_theme_tag', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/theme/deleteThemeTag?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_theme_tag = createAsyncThunk('delete_all_theme_tag', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/theme/deleteAllThemeTag`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

// Report Reason
export const get_report_reason = createAsyncThunk('get_report_reason', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getCommentReasonReport;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getCommentReasonReport = await API.post(`/admin/theme/getCommentReasonReport?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getCommentReasonReport = await API.get(`/admin/theme/getCommentReasonReport`);
        }

        // if (getCommentReasonReport) {
        const { status, data, currentPage, perPage, totalPage } = getCommentReasonReport?.data;
        if (status) {
            apiData = data;
            ;
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        // }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const add_report_reason = createAsyncThunk('add_report_reason', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const { data } = await API.post(`/admin/theme/addCommentReasonReport`, payload);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(handleChildClose());
            dispatch(setCurrentHomeModalKey(""));
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_report_reason = createAsyncThunk('update_report_reason', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const { data } = await API.patch(`/admin/theme/updateCommentReasonReport?id=${id}`, payload);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_report_reason = createAsyncThunk('delete_report_reason', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/theme/deleteCommentReasonReport?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_report_reason = createAsyncThunk('delete_all_report_reason', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/theme/deleteAllCommentReasonReport`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

// Reported Comment
export const get_reported_comment = createAsyncThunk('get_reported_comment', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getReportedComment;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getReportedComment = await API.post(`/admin/theme/getReportedComment?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getReportedComment = await API.get(`/admin/theme/getReportedComment`);
        }

        // if (getReportedComment) {
        const { status, data, currentPage, perPage, totalPage } = getReportedComment?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData(data));
            dispatch(setDeleteUpdateTag(""));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        // }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const delete_reject_reported_comment = createAsyncThunk('get_reject_reported_comment', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/theme/keepComment?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const allow_reported_comment = createAsyncThunk('allow_reported_comment', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/theme/deleteComment?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})
// Theme Tag
export const get_theme_hashtag = createAsyncThunk('get_theme_hashtag', async (payload, { rejectWithValue, dispatch, getState }) => {

    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getThemeHashtag;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getThemeHashtag = await API.post(`/admin/theme/getThemeHashtag?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getThemeHashtag = await API.get(`/admin/theme/getThemeHashtag`);
        }

        // if (getThemeTag) {
        const { status, data, currentPage, perPage, totalPage } = getThemeHashtag?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));

        }
        // }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

// theme hashtag dropdown
export const get_theme_hashtag_dropdown = createAsyncThunk('get_theme_hashtag_dropdown', async (payload, { rejectWithValue, dispatch, getState }) => {

    try {
        // dispatch(setIsLoading(true));
        let getThemeHashtag = await API.post(`/admin/theme/getThemeHashtag?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search}`, payload?.filterDropdown);

        // if (getThemeTag) {
        const { data } = getThemeHashtag;

        // }
        // dispatch(setIsLoading(false));
        return data.data;
    } catch (error) {
        // dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})


export const add_theme_hashtag = createAsyncThunk('add_theme_hashtag', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const { data } = await API.post(`/admin/theme/addThemeHashtag`, payload);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_theme_hashtag_child = createAsyncThunk('add_theme_hashtag_child', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const { data } = await API.post(`/admin/theme/addThemeHashtag`, payload);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleChildClose());
            dispatch(setCurrentHomeModalKey(""));
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_theme_hashtag = createAsyncThunk('update_theme_hashtag', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const { data } = await API.patch(`/admin/theme/updateThemeHashtag?id=${id}`, payload);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_theme_hashtag = createAsyncThunk('delete_theme_hashtag', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/theme/deleteThemeHashtag?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_theme_hashtag = createAsyncThunk('delete_all_theme_hashtag', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/theme/deleteAllThemeHashtag`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const get_theme_categories_data = createAsyncThunk('get_theme_categories_data', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getStickerStore;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getStickerStore = await API.post(`/admin/theme/getThemeCategory?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getStickerStore = await API.get(`/admin/theme/getThemeCategory`);
        }
        const { status, data, currentPage, perPage, totalPage } = getStickerStore?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        dispatch(setIsLoading(false));
        return apiData;
    }
    catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const get_theme_categories_dropdown = createAsyncThunk('get_theme_categories_dropdown', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const getThemeCategory = await API.post(`/admin/theme/getThemeCategory?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search}`, payload?.filterDropdown);
        const { data } = getThemeCategory;

        return data.data;
    } catch (error) {
        return errorResponse(error, dispatch);
    }
})

export const update_theme_category = createAsyncThunk('update_theme_category', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.patch(`/admin/theme/updateThemeCategory?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_theme_category = createAsyncThunk('add_theme_category', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.post(`/admin/theme/addThemeCategory`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(handleChildClose());
            dispatch(setCurrentHomeModalKey(""));
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_theme_category_child = createAsyncThunk('add_theme_category_child', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.post(`/admin/theme/addThemeCategory`, formData);
        if (data?.status) {
            dispatch(handleChildClose());
            dispatch(setCurrentHomeModalKey(""));
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_theme_category = createAsyncThunk('delete_theme_category', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/theme/deleteThemeCategory?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        if (error?.response?.data?.status === false) {
            dispatch(setToastMessage({ type: 'error', message: error?.response?.data?.message }));
        }
        return errorResponse(error, dispatch);
    }
})

export const delete_all_theme_category = createAsyncThunk('delete_all_theme_category', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/theme/deleteAllThemeCategory`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

// theme color 
export const get_theme_color_dropdown = createAsyncThunk('get_theme_color_dropdown', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        let apiData;
        const getStickerStore = await API.post(`/admin/theme/getThemeColor`, { isActive: true });
        const { status, data } = getStickerStore?.data;
        if (status) {
            apiData = data;
        } else {
            apiData = []

        }
        return apiData;
    } catch (error) {
        return errorResponse(error, dispatch);
    }
})

export const get_theme_color = createAsyncThunk('get_theme_color', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true))
        let apiData;
        let getStickerStore;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getStickerStore = await API.post(`/admin/theme/getThemeColor?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getStickerStore = await API.post(`/admin/theme/getThemeColor`);
        }
        const { status, data, currentPage, perPage, totalPage } = getStickerStore?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));

        }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const update_theme_color = createAsyncThunk('update_theme_color', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        // const formData = setFormDataPayload(payload)
        const formData = payload
        const { data } = await API.patch(`/admin/theme/updateThemeColor?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_theme_color = createAsyncThunk('add_theme_color', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        // const formData = setFormDataPayload(payload)
        const formData = payload
        const { data } = await API.post(`/admin/theme/addThemeColor`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_theme_color = createAsyncThunk('delete_theme_color', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/theme/deleteThemeColor?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_theme_color = createAsyncThunk('delete_all_theme_color', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/theme/deleteAllThemeColor`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

// Theme Store
export const get_theme = createAsyncThunk('get_theme', async (payload, { rejectWithValue, dispatch, getState }) => {

    try {
        // dispatch(setIsLoading(true));
        let apiData;
        let getTheme;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getTheme = await API.post(`/admin/theme/getTheme?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getTheme = await API.get(`/admin/theme/getTheme`);
        }

        // if (getThemeTag) {
        const { status, data, currentPage, perPage, totalPage } = getTheme?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            dispatch(setPerPage(perPage || 15))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));

        }
        // }
        // dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const add_theme = createAsyncThunk('add_theme', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.post(`/admin/theme/addTheme`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_theme = createAsyncThunk('update_theme', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.patch(`/admin/theme/updateTheme?id=${id}`, formData);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_theme = createAsyncThunk('delete_theme', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/theme/deleteTheme?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_theme = createAsyncThunk('delete_all_theme', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/theme/deleteAllTheme`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})






export const get_feedback_subcategory = createAsyncThunk('get_feedback_subcategory', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let FeedbackSubCategory;
        if (payload?.search || payload?.id || payload?.filterDropdown) {
            FeedbackSubCategory = await API.post(`/admin/feedback/getFeedbackSubCategory?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search}`, { categoryId: payload?.id });
        } else {
            FeedbackSubCategory = await API.post(`/admin/feedback/getFeedbackSubCategory`);
        }

        if (FeedbackSubCategory) {
            const { status, data } = FeedbackSubCategory.data;
            if (status) {
                dispatch(setIsLoading(false));
                return data;
            } else {
                dispatch(setIsLoading(false));
                return [];
            }
        } else {
            dispatch(setIsLoading(false));
            return []
        }
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})





export const get_theme_comment = createAsyncThunk('get_theme_comment', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let ThemeComment;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            ThemeComment = await API.post(`/admin/theme/getThemeComment?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            ThemeComment = await API.get(`/admin/theme/getThemeComment`);
        }
        const { status, data, currentPage, perPage, totalPage } = ThemeComment?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setTotalPage(0))
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        return errorResponse(error, dispatch);
    }
})

export const update_theme_comment = createAsyncThunk('update_theme_comment', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        // const formData = setFormDataPayload(payload)
        const formData = payload
        const { data } = await API.patch(`/admin/theme/updateThemeComment?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_theme_comment = createAsyncThunk('add_theme_comment', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        // const formData = setFormDataPayload(payload)
        const formData = payload
        const { data } = await API.post(`/admin/theme/addThemeComment`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_theme_comment = createAsyncThunk('delete_theme_comment', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/theme/deleteThemeComment?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_theme_comment = createAsyncThunk('delete_all_theme_comment', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/theme/deleteAllThemeComment`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

// banner store

export const get_banner_store = createAsyncThunk('get_banner_store', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        let apiData;
        let getbannerStore;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            getbannerStore = await API.get(`/admin/store/getBanner?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            getbannerStore = await API.get(`/admin/store/getBanner`);
        }
        const { status, data, currentPage, perPage, totalPage } = getbannerStore?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));

        }
        return apiData;
    } catch (error) {
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const update_banner_store = createAsyncThunk('update_banner_store', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.patch(`/admin/store/updateBanner?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setToastMessage({ type: 'error', message: error?.message }));
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_banner_store = createAsyncThunk('add_banner_store', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.post(`/admin/store/addBanner`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})
export const delete_banner_store = createAsyncThunk('delete_banner_store', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/store/deleteBanner?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_banner_store = createAsyncThunk('delete_all_banner_store', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/store/deleteAllBanner`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

// json Api
export const add_lense_json = createAsyncThunk('add_lense_json', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        // const formData = payload
        const formData = setFormDataPayload(payload)
        const { lenseJsonImg, ...payloadWithoutImg } = payload;
        const json = JSON.stringify(payloadWithoutImg);
        formData.append('json', json)
        const { data } = await API.post(`/admin/createJson/createLenseJson`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_keys_json = createAsyncThunk('add_lense_json', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        // const formData = payload
        const formData = setFormDataPayload(payload)
        const { ledJsonImg, ...payloadWithoutImg } = payload;
        const json = JSON.stringify(payloadWithoutImg);
        formData.append('json', json)
        const { data } = await API.post(`/admin/createJson/createLedJson`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_Effect_json = createAsyncThunk('add_Effect_json', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { touchEffectJsonImg, ...payloadWithoutImg } = payload;
        const json = JSON.stringify(payloadWithoutImg);
        formData.append('json', json)
        const { data } = await API.post(`/admin/createJson/createTouchEffectJson`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const get_encoding_string = createAsyncThunk('get_encoding_string', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        let apiData;
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const formData = payload
        const { status, data } = await API.post(`/admin/encode/getEncodingString`, formData);
        if (status) {
            handleClose();
            apiData = data;
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(setEncodingString([]));
            dispatch(setEncodingString(data));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
        } else {
            dispatch(setEncodingString([]));
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return apiData;

    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})


// Zip Validation
export const zip_validation = createAsyncThunk('zip_validation', async (payload, { rejectWithValue, dispatch, getState }) => {

    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;

        const formData = setFormDataPayload(payload)
        const { data } = await API.post(`/admin/zipFile/zipFileValidation`, formData);
        if (data?.status) {
            dispatch(setZipValidationMessage({ status: true, message: data?.message }));
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
        } else {
            dispatch(setZipValidationMessage({ status: false, message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setZipValidationMessage(error?.response?.data));
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})


export const get_history = createAsyncThunk('get_history', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        let apiData;
        let getHistory;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown) {
            getHistory = await API.post(`/admin/history/getHistory?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search || ''}`, payload?.filterDropdown);
        } else {
            getHistory = await API.post(`/admin/history/getHistory`);
        }
        const { status, data, currentPage, perPage, totalPage } = getHistory?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        return apiData;
    } catch (error) {
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const get_history_filterList = createAsyncThunk(
    'get_history_filterList',
    async (page, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setIsLoading(true));
            const { data } = await API.get(`/admin/history/getHistoryFilterList`);
            dispatch(setIsLoading(false));
            return data.data;
        } catch (error) {
            dispatch(setIsLoading(false));
            return errorResponse(error, dispatch);
        }
    }
)

export const get_History_ById = createAsyncThunk('get_History_ById', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const { data } = await API.get(`/admin/history/getHistoryById?id=${id}`);
        if (data?.status) {
            // dispatch(setToastMessage({ type: 'success', message: data?.message }));
            // dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            return data.data;
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const get_config_link = createAsyncThunk('get_config_link', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getConfigData;
        getConfigData = await API.post(`/admin/configManager/getConfigLink`);

        const { status, data } = getConfigData?.data;
        if (status) {
            apiData = data;
            dispatch(setConfigData(data));
        } else {
            dispatch(setConfigData([]));
        }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_banner_priority = createAsyncThunk('update_banner_priority', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const { data } = await API.post('/admin/store/updateBannerpriority', payload);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            // dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})



export const add_subscription_icon = createAsyncThunk('add_subscription_icon', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        // const formData = payload
        const { data } = await API.post(`/admin/subscriptionIcon/addsubscriptionIcon`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})


export const get_subscription_icon = createAsyncThunk('get_subscription_icon', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let FeedbackCategory;
        if (payload?.currentPage || payload?.perPage || payload?.search || payload?.filterDropdown || payload?.sortName || payload?.sortType) {
            FeedbackCategory = await API.post(`/admin/subscriptionIcon/getSubscriptionIcon?page=${payload?.currentPage}&perPage=${payload?.perPage}&search=${payload?.search}&sortName=${payload?.sortData}&sortType=${payload?.isAscending}`, payload?.filterDropdown);
        } else {
            FeedbackCategory = await API.get(`/admin/subscriptionIcon/getSubscriptionIcon`);
        }
        const { status, data, currentPage, perPage, totalPage } = FeedbackCategory?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const update_subscription_icon = createAsyncThunk('update_subscription_icon', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        // const formData = payload
        const { data } = await API.patch(`/admin/subscriptionIcon/updateSubscriptionIcon?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})


export const delete_subscription_icon = createAsyncThunk('delete_subscription_icon', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/subscriptionIcon/deleteSubscriptionIcon?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_subscription_icon = createAsyncThunk('delete_all_subscription_icon', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/subscriptionIcon/deleteAllSubscriptionIcon`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_sticker = createAsyncThunk('add_sticker', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        const formData = setFormDataPayload(payload)
        dispatch(setIsModalLoading(true));
        const { data } = await API.post(`/admin/stickergeneration/addStikcer`, formData);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleChildClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_sticker = createAsyncThunk('update_sticker', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.patch(`/admin/stickergeneration/updateSticker?id=${id}`, formData);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleChildClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const get_sticker = createAsyncThunk('get_sticker', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsChildLoading(true));
        let apiData;
        let getStickerList;
        if (payload?.search || payload?.filterDropdown) {
            getStickerList = await API.post(`/admin/stickergeneration/getSticker?search=${payload?.search || ''}`, payload?.filterDropdown);
        } else {
            getStickerList = await API.post(`/admin/stickergeneration/getSticker`);
        }

        // if (getBackgroundList) {
        const { status, data } = getStickerList?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageChildData([]));
            dispatch(setCurrentPageChildData(data));
        } else {
            dispatch(setCurrentPageChildData([]));
        }
        // }
        dispatch(setIsChildLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsChildLoading(false));
        dispatch(setCurrentPageChildData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const get_sticker_pack = createAsyncThunk('get_sticker_pack', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getBackgroundList;
        let urlString = `/admin/stickergeneration/getStickerPack?`
        if (payload?.currentPage) {
            urlString += `page=${payload?.currentPage}`
        }
        if (payload?.perPage) {
            urlString += `&perPage=${payload?.perPage}`
        }
        if (payload?.search) {
            urlString += `&search=${payload?.search}`
        }
        if (payload?.sortName) {
            urlString += `&sortName=${payload?.sortName}`
        }
        if (payload?.sortType) {
            urlString += `&sortType=${payload?.sortType}`
        }
        getBackgroundList = await API.post(urlString, payload?.filterDropdown);


        // if (getBackgroundList) {
        const { status, data, currentPage, perPage, totalPage } = getBackgroundList?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        // }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const get_sticker_category_dropdown_data = createAsyncThunk('get_sticker_category_dropdown_data', async ({ currentPage = 1, perPage, search, filterDropdown }, { rejectWithValue, dispatch, getState }) => {
    try {
        // dispatch(setIsLoading(true));
        if (currentPage || perPage || search || filterDropdown) {
            const { data } = await API.post(`/admin/stickergeneration/getStickerCategory?page=${currentPage}&perPage=${perPage}&search=${search}`, filterDropdown)
            // dispatch(setIsLoading(false));
            return data.data;
        } else {
            const { data } = await API.post(`/admin/stickergeneration/getStickerCategory`)
            // dispatch(setIsLoading(false));
            return data.data;
        }

    } catch (error) {
        // dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_sticker_pack_priority = createAsyncThunk('update_sticker_pack_priority', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const { data } = await API.post('/admin/stickergeneration/updateStickerPackPriority', payload);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            // dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_sticker_pack = createAsyncThunk('add_sticker_pack', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.post(`admin/stickergeneration/addStickerPack`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(''))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        dispatch(setToastMessage({ type: 'error', message: "Sticker Pack already exist!" }));
        return errorResponse(error, dispatch);
    }
})

export const get_sticker_category_dropdown = createAsyncThunk('get_sticker_category_dropdown', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {

        let getBackgroundList = await API.get(`/admin/stickergeneration/getStickerCategoryDropDownList`, { isActive: true });

        // if (getBackgroundList) {
        const { status, data } = getBackgroundList?.data;
        if (status) {
            return data;
        } else {
            return [];
        }

    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_sticker_pack = createAsyncThunk('update_sticker_pack', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.patch(`/admin/stickergeneration/updateStickerPack?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setAddEditDeleteTag(''))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const get_sticker_pack_dropDown = createAsyncThunk('get_sticker_pack', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        let getBackgroundList;
        getBackgroundList = await API.post(`/admin/stickergeneration/getStickerPack`);
        const { status, data } = getBackgroundList?.data;
        if (status) {
            return data;
        } else {
            return [];
        }
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const get_sticker_store_dropdown = createAsyncThunk('get_sticker_store_dropdown', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.post(`/admin/sticker/getStickerTags`, formData);
        dispatch(setIsModalLoading(false));
        return data.data
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})
export const delete_all_sticker_pack = createAsyncThunk('delete_all_sticker_pack', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/stickergeneration/deleteAllStickerPack`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_sticker_pack = createAsyncThunk('delete_sticker_pack', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/stickergeneration/deleteStickerPack?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_sticker = createAsyncThunk('delete_sticker', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/stickergeneration/deleteSticker?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setToastMessage({ type: 'error', message: "Default Icon cannot be deleted." }));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_sticker = createAsyncThunk('delete_all_sticker', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/stickergeneration/deleteAllSticker`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_settings = createAsyncThunk('update_settings', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const formData = payload
        const { data } = await API.patch(`/admin/setting/updateSettings?id=${id}`, formData);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(handleClose());
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})


export const add_settings = createAsyncThunk('add_settings', async (payload, { rejectWithValue, dispatch, getState }) => {

    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;

        dispatch(setIsModalLoading(true));
        const formData = payload
        const { data } = await API.post(`/admin/setting/addSettings`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(handleClose());
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const get_setting_limit = createAsyncThunk('get_setting_limit', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        const getSettingScreenRedirection = await API.post(`/admin/setting/getSettings`);
        const { status, data } = getSettingScreenRedirection?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
        } else {
            dispatch(setCurrentPageData([]));
        }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        return errorResponse(error, dispatch);
    }
})


export const delete_settings = createAsyncThunk('delete_settings', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/setting/deleteSettings?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const get_HomeScreen_Redirection = createAsyncThunk('get_HomeScreen_Redirection', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getHomeScreenRedirection;
        let urlString = `/admin/homeScreen/redirection/getHomeScreenRedirection?`
        if (payload?.currentPage) {
            urlString += `page=${payload?.currentPage}`
        }
        if (payload?.perPage) {
            urlString += `&perPage=${payload?.perPage}`
        }
        if (payload?.search) {
            urlString += `&search=${payload?.search}`
        }
        if (payload?.sortName) {
            urlString += `&sortName=${payload?.sortName}`
        }
        if (payload?.sortType) {
            urlString += `&sortType=${payload?.sortType}`
        }
        getHomeScreenRedirection = await API.post(urlString, payload?.filterDropdown);

        const { status, data, currentPage, perPage, totalPage } = getHomeScreenRedirection?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));

        }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})


export const get_homeScreen_redirection_dropdown = createAsyncThunk('get_homeScreen_redirection_dropdown', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        // let apiData;
        let getHomeScreenRedirection = await API.post(`/admin/homeScreen/redirection/getHomeScreenRedirection`, payload, payload?.filterDropdown);
        const { data } = getHomeScreenRedirection?.data;
        return data;
    } catch (error) {
        return errorResponse(error, dispatch);
    }
})


export const update_HomeScreen_Redirection = createAsyncThunk('update_HomeScreen_Redirection', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        // const formData = setFormDataPayload(payload)
        const formData = payload
        const { data } = await API.patch(`/admin/homeScreen/redirection/updateHomeScreenRedirection?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_HomeScreen_Redirection = createAsyncThunk('add_HomeScreen_Redirection', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        // const formData = setFormDataPayload(payload)
        const formData = payload
        const { data } = await API.post(`/admin/homeScreen/redirection/addHomeScreenRedirection`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_HomeScreen_Redirection = createAsyncThunk('delete_HomeScreen_Redirection', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/homeScreen/redirection/deleteHomeScreenRedirection?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_HomeScreen_Redirection = createAsyncThunk('delete_All_HomeScreen_Redirection', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/homeScreen/redirection/deleteAllHomeScreenRedirection`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_homeScreen_functionality_store = createAsyncThunk('update_HomeScreen_Functionality_Store', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        // const formData = payload
        const { data } = await API.patch(`/admin/homeScreen/functionality/updateHomeScreenFunctionalityStore?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(handleChildClose());
            dispatch(setFormData({}));
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const add_homeScreen_functionality_store = createAsyncThunk('add_HomeScreen_Functionality_Store', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        // const formData = payload
        const { data } = await API.post(`/admin/homeScreen/functionality/addHomeScreenFunctionalityStore`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(handleChildClose())
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})


export const add_custom_section = createAsyncThunk('add_custom_section', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.post(`/admin/homeScreen/customBanner/addHomeScreenCustomBanner`, formData);
        if (data?.status) {
            handleClose();
            dispatch(handleChildClose())
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_custom_section = createAsyncThunk('update_custom_section', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        let formData = setFormDataPayload(payload);
        const { data } = await API.patch(`/admin/homeScreen/customBanner/updateHomeScreenCustomBanner?id=${id}`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose())
            dispatch(handleChildClose())
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_custom_section = createAsyncThunk('delete_custom_section', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`admin/homeScreen/customBanner/deleteHomeScreenCustomBanner?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})


// homescreen
export const get_homescreen_section = createAsyncThunk('get_homescreen_section', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        const getHomescreenData = await API.post(`admin/homeScreen/section/getHomeScreenSection`);


        // if (getBackgroundList) {
        const { status, data, currentPage, perPage, totalPage } = getHomescreenData?.data;
        if (status) {
            apiData = data;
            dispatch(setHomeScreenSectionData([]));
            dispatch(setHomeScreenSectionData(data));
            dispatch(setCurrentPage(currentPage));
            // dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setHomeScreenSectionData([]));
        }
        // }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const add_homescreen_section = createAsyncThunk('add_homescreen_section', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.post(`/admin/homeScreen/section/addHomeScreenSection`, formData);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_homescreen_section = createAsyncThunk('update_homescreen_section', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        let formData = setFormDataPayload(payload);
        const { data } = await API.patch(`admin/homeScreen/section/updateHomeScreenSection?id=${id}`, formData);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_homescreen_section = createAsyncThunk('delete_homescreen_section', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/homeScreen/section/deleteHomeScreenSection?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_homescreen_section = createAsyncThunk('delete_all_homescreen_section', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/homeScreen/section/deleteAllHomeScreenSection`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_homescreen_section_priority = createAsyncThunk('update_homescreen_section_priority', async ({ payload }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;

        const { data } = await API.patch(`admin/homeScreen/section/updateSectionPriority`, payload);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const get_homescreen_data = createAsyncThunk('get_homescreen_data', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        const getHomescreenData = await API.get(`admin/homeScreen/section/getHomeScreenData`);


        // if (getBackgroundList) {
        const { status, data, currentPage, perPage, totalPage } = getHomescreenData?.data;
        if (status) {
            apiData = data;
            dispatch(setHomeScreenData([]));
            dispatch(setHomeScreenData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setHomeScreenData([]));

        }
        // }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setHomeScreenData([]));
        dispatch(setIsLoading(false));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const get_AvatarPack_DropDownList = createAsyncThunk('get_AvatarPack_DropDownList', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {

        let getBackgroundList = await API.post(`/admin/avatar/getAvatarPackDropDownList`, { isActive: true });

        // if (getBackgroundList) {
        const { status, data } = getBackgroundList?.data;
        if (status) {
            return data;
        } else {
            return [];
        }

    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const get_version_dropdown = createAsyncThunk('get_version', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let FeedbackCategory;
        let urlString = `/admin/version/getVersion?`
        if (payload?.currentPage) {
            urlString += `page=${payload?.currentPage}`
        }
        if (payload?.perPage) {
            urlString += `&perPage=${payload?.perPage}`
        }
        if (payload?.search) {
            urlString += `&search=${payload?.search}`
        }
        if (payload?.sortName) {
            urlString += `&sortName=${payload?.sortName}`
        }
        if (payload?.sortType) {
            urlString += `&sortType=${payload?.sortType}`
        }
        FeedbackCategory = await API.post(urlString, payload?.filterDropdown);

        const { data } = FeedbackCategory?.data;
        apiData = data;

        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})
export const delete_version = createAsyncThunk('delete_version', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/version/deleteVersion?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})
export const update_version = createAsyncThunk('update_version', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        // const formData = payload
        const { data } = await API.patch(`/admin/version/updateVersion?id=${id}`, payload);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
            // navigate('/blogs')
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
    }
})

export const add_version = createAsyncThunk('add_version', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        // const formData = payload
        const { data } = await API.post(`/admin/version/addVersion`, payload);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const get_version = createAsyncThunk('get_version', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let FeedbackCategory;
        let urlString = `/admin/version/getVersion?`
        if (payload?.currentPage) {
            urlString += `page=${payload?.currentPage}`
        }
        if (payload?.perPage) {
            urlString += `&perPage=${payload?.perPage}`
        }
        if (payload?.search) {
            urlString += `&search=${payload?.search}`
        }
        if (payload?.sortName) {
            urlString += `&sortName=${payload?.sortName}`
        }
        if (payload?.sortType) {
            urlString += `&sortType=${payload?.sortType}`
        }
        FeedbackCategory = await API.post(urlString, payload?.filterDropdown);

        const { status, data, currentPage, perPage, totalPage } = FeedbackCategory?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})




//Rc Config
export const get_rc_config = createAsyncThunk('get_rc_config', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        const getHomescreenData = await API.post(`/admin/rcconfig/getRcConfig`);
        const { status, data } = getHomescreenData?.data;
        if (status) {
            dispatch(setFormData({ id: data?._id, rcjson: data?.json || "" }));
        }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setCurrentPageData([]));
        return errorResponse(error, dispatch);
    }
})

export const add_rc_config = createAsyncThunk('add_rc_config', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;

        dispatch(setIsLoading(true));
        // const formData = setFormDataPayload(payload)
        const { data } = await API.post(`/admin/rcconfig/addRcConfig`, payload);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_rc_config = createAsyncThunk('update_rc_config', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        const { data } = await API.patch(`/admin/rcconfig/updateRcConfig?id=${id}`, payload);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return data;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_rc_config = createAsyncThunk('delete_rc_config', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/rcconfig/deleteRcConfig?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

//rc foto keyboard config
export const get_fk_config = createAsyncThunk('get_fk_config', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        const getHomescreenData = await API.post(`/admin/fkconfig/getFkConfig`);
        const { status, data } = getHomescreenData?.data;
        if (status) {
            dispatch(setFormData({ id: data?._id, rcjson: data?.json || "" }));
        }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setCurrentPageData([]));
        return errorResponse(error, dispatch);
    }
})

export const add_fk_config = createAsyncThunk('add_fk_config', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        // const formData = setFormDataPayload(payload)
        const { data } = await API.post(`/admin/fkconfig/addFkConfig`, payload);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_fk_config = createAsyncThunk('update_fk_config', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        const { data } = await API.patch(`/admin/fkconfig/updateFkConfig?id=${id}`, payload);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return data;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_sticker_store = createAsyncThunk('update_sticker_store', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const hasFilePayload = Object.values(payload ?? {}).some(
            (value) => value instanceof File || value instanceof FileList
        );
        const { id: _payloadId, ...body } = payload ?? {};
        const { data } = hasFilePayload
            ? await API.patch(`/admin/sticker/updateSticker?id=${id}`, setFormDataPayload(payload))
            : await API.patch(`/admin/sticker/updateSticker?id=${id}`, body);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            if (reload) {
                handleClose();
                dispatch(handleClose());
                dispatch(setMultiCountry([]))
                dispatch(setMultiRegion([]))
            }
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})


export const add_sticker_store = createAsyncThunk('add_sticker_store', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const formData = setFormDataPayload(payload)
        const { data } = await API.post(`/admin/sticker/addSticker`, formData);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})


export const add_sticker_tags_dropdown = createAsyncThunk('add_sticker_tags_dropdown', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        // const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const { data } = await API.post(`/admin/sticker/addStickerTags`, payload);
        if (data?.status) {
            // dispatch(setToastMessage({ type: 'success', message: data?.message }));
            // dispatch(handleClose());
            // dispatch(setDeleteUpdateTag(deleteUpdateYes))
            // dispatch(setMultiCountry([]))
            // dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})


export const get_sticker_tags_dropdown = createAsyncThunk('get_sticker_tags_dropdown', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsModalLoading(true));
        const params = payload ?? { currentPage: 1, perPage: '', search: '', filterDropdown: { isActive: true } };
        let urlString = `/admin/sticker/getStickerTags?`
        if (params?.currentPage) {
            urlString += `page=${params.currentPage}`
        }
        if (params?.perPage !== undefined && params?.perPage !== null) {
            urlString += `&perPage=${params.perPage}`
        }
        if (params?.search !== undefined && params?.search !== null) {
            urlString += `&search=${params.search}`
        }
        const { data } = await API.post(urlString, params?.filterDropdown ?? { isActive: true });
        dispatch(setIsModalLoading(false));
        return data.data
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const get_sticker_store = createAsyncThunk('get_sticker_store', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getStickerStore;

        let urlString = `/admin/sticker/getSticker?`

        if (payload?.currentPage) {
            urlString += `page=${payload?.currentPage}`
        }
        if (payload?.perPage) {
            urlString += `&perPage=${payload?.perPage}`
        }
        if (payload?.search) {
            urlString += `&search=${payload?.search}`
        }
        if (payload?.sortName) {
            urlString += `&sortName=${payload?.sortName}`
        }
        if (payload?.sortType) {
            urlString += `&sortType=${payload?.sortType}`
        }


        getStickerStore = await API.post(urlString, payload?.filterDropdown);

        const { status, data, currentPage, perPage, totalPage } = getStickerStore?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));
        }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})


// Theme Tag
export const get_sticker_Tag = createAsyncThunk('get_sticker_Tag', async (payload, { rejectWithValue, dispatch, getState }) => {

    try {
        dispatch(setIsLoading(true));
        let apiData;
        let getTheme;
        let urlString = `/admin/sticker/getStickerTags?`
        if (payload?.currentPage) {
            urlString += `page=${payload?.currentPage}`
        }
        if (payload?.perPage) {
            urlString += `&perPage=${payload?.perPage}`
        }
        if (payload?.search) {
            urlString += `&search=${payload?.search}`
        }
        if (payload?.sortName) {
            urlString += `&sortName=${payload?.sortName}`
        }
        if (payload?.sortType) {
            urlString += `&sortType=${payload?.sortType}`
        }
        getTheme = await API.post(urlString, payload?.filterDropdown);

        // if (getThemeTag) {
        const { status, data, currentPage, perPage, totalPage } = getTheme?.data;
        if (status) {
            apiData = data;
            dispatch(setCurrentPageData([]));
            dispatch(setCurrentPageData(data));
            dispatch(setCurrentPage(currentPage));
            //  dispatch(setPerPage(perPage))
            dispatch(setTotalPage(totalPage))
        } else {
            dispatch(setCurrentPageData([]));

        }
        // }
        dispatch(setIsLoading(false));
        return apiData;
    } catch (error) {
        dispatch(setIsLoading(false));
        dispatch(setCurrentPageData([]));
        dispatch(setTotalPage(0));
        return errorResponse(error, dispatch);
    }
})

export const add_sticker_Tag = createAsyncThunk('add_sticker_Tag', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsModalLoading(true));
        const { data } = await API.post(`/admin/sticker/addStickerTags`, payload);
        if (data?.status) {
            handleClose();
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
            dispatch(setMultiCountry([]))
            dispatch(setMultiRegion([]))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const update_sticker_Tag = createAsyncThunk('update_sticker_Tag', async ({ id, payload, reload = true }, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        reload && dispatch(setIsModalLoading(true));
        const { id: _payloadId, ...body } = payload ?? {};
        const { data } = await API.patch(`/admin/sticker/updateStickerTags?id=${id}`, body);
        if (data?.status) {
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            if (reload) {
                handleClose();
                dispatch(handleClose());
                dispatch(setMultiCountry([]))
                dispatch(setMultiRegion([]))
            }
            dispatch(setDeleteUpdateTag(deleteUpdateYes))
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsModalLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_sticker_store = createAsyncThunk('delete_sticker_store', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/sticker/deleteSticker?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_sticker_store = createAsyncThunk('delete_all_sticker_store', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/sticker/deleteAllSticker`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_sticker_Tag = createAsyncThunk('delete_sticker_Tag', async (id, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.delete(`/admin/sticker/deleteStickerTags?id=${id}`);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsLoading(false));
        return errorResponse(error, dispatch);
    }
})

export const delete_all_sticker_Tag = createAsyncThunk('delete_all_sticker_Tag', async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
        const deleteUpdateYes = getState().context.deleteUpdateYes;
        dispatch(setIsLoading(true));
        const { data } = await API.post(`/admin/sticker/deleteAllStickerTags`, payload);
        if (data?.status) {
            dispatch(setCurrentPageData([]))
            dispatch(setToastMessage({ type: 'success', message: data?.message }));
            dispatch(handleClose());
            dispatch(setDeleteUpdateTag(deleteUpdateYes));
        } else {
            dispatch(setToastMessage({ type: 'error', message: data?.message }));
        };
        dispatch(setIsLoading(false));
        return;
    } catch (error) {
        dispatch(setIsModalLoading(false));
        return errorResponse(error, dispatch);
    }
})

